import React from 'react';
import {Link} from 'react-router-dom';
import Navigation from '../utils/Navigation';
import SeoHelmet from '../utils/seo';
import {useTheme} from '../header/Header';
import {ProductFaq} from '../product/ProductCard';
import '../../css/lizing/leasing-refresh.css';
import '../../css/lizing/rosagro.css';


const source = 'https://www.sespel.com/about/lizing/lizing-ot-ao-rosagrolizing/';

const FAQ_ITEMS = [
    {
        question: 'Кто может подать заявку на лизинг через Росагролизинг?',
        answer: 'Юридические лица и ИП, работающие в сфере АПК не менее года, без просроченной задолженности по налогам, сборам и кредитам.'
    },
    {
        question: 'Какой минимальный первоначальный взнос?',
        answer: 'От 0% — размер первого взноса не зависит от предмета лизинга.'
    },
    {
        question: 'На какой срок можно оформить лизинг?',
        answer: 'До 7 лет. Доступны как аннуитетные (равные), так и гибкие графики платежей.'
    },
    {
        question: 'Нужен ли залог или поручительство?',
        answer: 'Нет. Гарантийное обеспечение и дополнительный залог не требуются — обеспечением выступает сам предмет лизинга.'
    },
    {
        question: 'Сколько рассматривается заявка?',
        answer: 'Решение по льготной программе принимается за 1 рабочий день.'
    },
    {
        question: 'Можно ли оформить сделку дистанционно?',
        answer: 'Да. Электронная подпись позволяет провести сделку онлайн без визита в офис, почтовых расходов и риска потери документов.'
    },
    {
        question: 'Какая минимальная сумма сделки?',
        answer: 'От 400 000 ₽. Сделки заключаются по всей России.'
    }
];

const SESPEL_FINANCE_LEASING = [
    {
        url: '/lizing/lizing_finance',
        title: 'Лизинг от «Сеспель-Финанс»',
        image: 'lizing/lizingSespelFinance.webp'
    }
];

const getImage = (path) => {
    if (!path) return "";
    const clean = path.replace(/^\.?\//, "");
    return `/images/${clean}`;
};

export default function LizingRosagro() {
    const {theme} = useTheme();

    return <>
        <Navigation/>
        <SeoHelmet
            title="Лизинг от АО «Росагролизинг» — Сеспель"
            description="Программы лизинга техники Сеспель от АО «Росагролизинг»: от 0% первый взнос, срок до 7 лет, решение за 1 день. Требования, порядок оформления и ответы на частые вопросы."
            canonicalUrl="/lizing/lizing_rosagro"
        />
        <div className="overlay">
            <div className={`complexBack ${theme}`}/>
            <main className={`leasing-page rosagro-page ${theme}`}>

                {/* Hero */}
                <section className="leasing-hero rosagro-hero">
                    <div className="leasing-hero-copy">
                        <span className="leasing-eyebrow">Техника Сеспель · Финансирование</span>
                        <h1>Лизинг от АО «Росагролизинг»</h1>
                        <p>Федеральная программа обновления техники для агропромышленного комплекса: от 0% первый взнос, срок до 7 лет, решение за 1 день.</p>
                        <div className="leasing-actions">
                            <a className="leasing-button" href="#rosagro-programs">
                                Условия программ <span aria-hidden="true">↗</span>
                            </a>
                            <a className="leasing-contact" href="tel:+79034764230">
                                Консультация специалиста ↗
                            </a>
                        </div>
                        <ul className="rosagro-hero-facts">
                            <li><strong>от 0%</strong><span>первый взнос</span></li>
                            <li><strong>до 7 лет</strong><span>срок лизинга</span></li>
                            <li><strong>1 день</strong><span>решение по заявке</span></li>
                        </ul>
                    </div>
                    <div className="rosagro-hero-panel">
                        <span className="leasing-eyebrow">АО «Росагролизинг»</span>
                        <strong>от 0%</strong>
                        <p>первоначальный взнос</p>
                        <span>Для предприятий агропромышленного комплекса</span>
                    </div>
                </section>

                {/* Programs */}
                <section id="rosagro-programs" className="rosagro-section">
                    <div className="leasing-section-heading">
                        <span className="leasing-eyebrow">01 / Программы</span>
                        <h2>Условия финансирования</h2>
                        <p>Две программы Росагролизинга под разные задачи предприятия.</p>
                    </div>

                    <div className="rosagro-grid">
                        <article className="rosagro-card rosagro-card--accent">
                            <header>
                                <h3>Федеральный лизинг</h3>
                                <span className="rosagro-tag">Для любых АПК-предприятий</span>
                            </header>
                            <dl>
                                <div><dt>Удорожание</dt><dd>от 7%</dd></div>
                                <div><dt>Срок</dt><dd>до 7 лет</dd></div>
                                <div><dt>Первый взнос</dt><dd>от 0%</dd></div>
                            </dl>
                            <p>Первый взнос не зависит от предмета лизинга. Подходит для обновления и расширения автопарка.</p>
                        </article>

                        <article className="rosagro-card rosagro-card--accent">
                            <header>
                                <h3>Льготный лизинг</h3>
                                <span className="rosagro-tag">Ускоренное рассмотрение</span>
                            </header>
                            <dl>
                                <div><dt>Первый взнос</dt><dd>от 0%</dd></div>
                                <div><dt>Срок</dt><dd>до 7 лет</dd></div>
                                <div><dt>Рассмотрение заявки</dt><dd>1 день</dd></div>
                            </dl>
                            <p>Гибкий график платежей и быстрое принятие решения. Идеально для сезонных задач.</p>
                        </article>
                    </div>

                    <ul className="rosagro-summary-list">
                        <li>Сделки от <strong>400 000 ₽</strong> по всей России</li>
                        <li>Аннуитетные или гибкие платежи</li>
                        <li>Гарантийное обеспечение и залог не требуются</li>
                    </ul>
                </section>

                {/* Participants */}
                <section className="rosagro-section rosagro-card">
                    <span className="leasing-eyebrow">02 / Участники</span>
                    <h2>Кому подходит программа</h2>
                    <ul className="rosagro-checklist">
                        <li>Юридическим лицам и ИП, производящим сельхозпродукцию, а также организациям её производства, переработки, сбыта и сельскохозяйственных услуг.</li>
                        <li>Срок работы компании — больше года.</li>
                        <li>Нет просроченных налогов, сборов, взносов, обязательных платежей и кредитов.</li>
                    </ul>
                </section>

                {/* Steps */}
                <section className="rosagro-section">
                    <span className="leasing-eyebrow">03 / Оформление</span>
                    <h2>Три шага к заявке</h2>

                    <ol className="rosagro-steps">
                        <li>
                            <span className="rosagro-step-num">01</span>
                            <h3>Заполните анкету</h3>
                            <p>Расскажите о компании и предмете лизинга.</p>
                        </li>
                        <li>
                            <span className="rosagro-step-num">02</span>
                            <h3>Соберите документы</h3>
                            <p>Стандартный пакет для юрлиц и ИП.</p>
                        </li>
                        <li>
                            <span className="rosagro-step-num">03</span>
                            <h3>Передайте в Росагролизинг</h3>
                            <p>Через личный кабинет или электронную подпись.</p>
                        </li>
                    </ol>

                    <div className="rosagro-card rosagro-card--cta">
                        <div>
                            <h3>Подайте документы дистанционно</h3>
                            <p>Электронная подпись позволяет оформить сделку онлайн без поездки в офис, почтовых расходов и риска потери документов.</p>
                            <p className="rosagro-muted">Почтовый адрес: 127137, Москва, а/я 26.</p>
                        </div>
                        <a className="leasing-button" href="https://www.rosagroleasing.ru/" target="_blank" rel="noopener noreferrer">
                            На сайт Росагролизинга <span aria-hidden="true">↗</span>
                        </a>
                    </div>
                </section>

                {/* FAQ — общий компонент */}
                <ProductFaq items={FAQ_ITEMS} theme={theme}/>

                {/* Contact */}
                <section className="rosagro-section rosagro-card rosagro-contact">
                    <div>
                        <h2>Поможем с выбором техники</h2>
                        <p>Специалист ответит на вопросы о технике Сеспель, комплектации и оформлении лизинга.</p>
                    </div>
                    <div>
                        <a className="leasing-phone" href="tel:+79034764230">+7 (903) 476-42-30</a>
                        <a className="rosagro-link" href={source} target="_blank" rel="noopener noreferrer">
                            Условия на сайте Сеспель ↗
                        </a>
                    </div>
                </section>

                <LeasingEquipment
                    items={SESPEL_FINANCE_LEASING}
                    theme={theme}
                    id="sespel-finance-program"
                    eyebrow="Лизинг от производителя"
                    title="Лизинг от «Сеспель-Финанс»"
                    description="Дочерняя лизинговая компания завода «Сеспель»: 5% первый взнос, техника по заводским ценам, решение за 1 день."
                />

                <Link className="rosagro-back" to="/lizing">← Все программы лизинга</Link>
            </main>
        </div>
    </>;
}

export function LeasingEquipment({
                                             items,
                                             theme,
                                             id = 'leasing-equipment',
                                             eyebrow = 'Оборудование завода',
                                             title = 'Техника, доступная в лизинг',
                                             description = 'Любую позицию каталога «Сеспель» можно взять по программам лизинга.'
                                         }) {
    if (!items?.length) return null;

    return (
        <section className={`related-equipment ${theme}`} aria-labelledby={`${id}-title`}>
            <div className="related-equipment__heading">
                <div>
                    <span className="related-equipment__eyebrow">{eyebrow}</span>
                    <h2 id={`${id}-title`}>{title}</h2>
                    {description && <p>{description}</p>}
                </div>
            </div>

            <div className="related-equipment__grid">
                {items.map(item => (
                    <Link className="related-equipment__card" to={item.url} key={item.url}>
                        <div className="related-equipment__photo">
                            {item.image && (
                                <img loading="lazy" src={getImage(item.image)} alt={item.title}/>
                            )}
                        </div>
                        <div className="related-equipment__content">
                            <h3>{item.title}</h3>
                            <span>Подробнее <span aria-hidden="true">→</span></span>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
}